module.exports = __webpack_public_path__ + "img/external_link_icon.afe0179f.svg";